import { PATH_PREFIX } from '../config/tenant';

// ── Screensaver Ring Carousel ──
// Add or remove rings here. Each entry needs an image URL, a ring builder URL, and a short description.
const SCREENSAVER_RINGS = [
  {
    description: 'Titanium',
    imageUrl:
      'https://assets.lashbrookdesigns.com/rings/profiles/D/widths/7/ring_materials/T/images/1?ring_finish=SATIN&finish_type=F&size=10&feature_group=N&sleeve=CER-RIDGEWAYBLUE&image_size=400&watermark=false',
    ringUrl: `/${PATH_PREFIX}/rings/profiles/D/widths/7/ring_materials/T?ring_finish=SATIN&finish_type=F&size=10&feature_group=N&sleeve=CER-RIDGEWAYBLUE`
  },
  {
    description: 'Zirconium',
    imageUrl:
      'https://assets.lashbrookdesigns.com/rings/profiles/B-NS/widths/7/ring_materials/Z/images/1?ring_finish=SATIN%2CPOLISH&finish_type=FS&size=10&feature_group=D%2CG&groove_group=%2C21-EDGE&grooves=%2C21-EDGE_SS_POLISH&gemstones=HALFETERNITY-N_ROUND_LABDIA-ST_.015_BEAD&image_size=400&watermark=false',
    ringUrl: `/${PATH_PREFIX}/rings/profiles/B-NS/widths/7/ring_materials/Z?ring_finish=SATIN%2CPOLISH&finish_type=FS&size=10&feature_group=D%2CG&groove_style=%2CEDGE&groove_group=%2C21-EDGE&grooves=%2C21-EDGE_SS_POLISH&sleeve=NONE&gemstones=HALFETERNITY-N_ROUND_LABDIA-ST_.015_BEAD`
  },
  {
    description: 'Cobalt Chrome',
    imageUrl:
      'https://assets.lashbrookdesigns.com/rings/profiles/FGE/widths/8/ring_materials/CC/images/1?ring_finish=SATIN%2CPOLISH&finish_type=FS&size=10&feature_group=M%2CN&machine_pattern=LCVASPEN_CC_COLOR_NONE&sleeve=HW-DESERTIRONWOOD&image_size=400&watermark=false',
    ringUrl: `/${PATH_PREFIX}/rings/profiles/FGE/widths/8/ring_materials/CC?ring_finish=SATIN%2CPOLISH&finish_type=FS&size=10&feature_group=M%2CN&machine_pattern=LCVASPEN_CC_COLOR_NONE&sleeve=HW-DESERTIRONWOOD`
  },
  {
    description: '14K Yellow Gold',
    imageUrl:
      'https://assets.lashbrookdesigns.com/rings/profiles/B-NS/widths/7/ring_materials/PF14KY/images/1?ring_finish=POLISH%2CPOLISH&finish_type=FS&size=10&feature_group=G%2CN&groove_group=15-N&grooves=15-N_ZIRCONIUM_ROCK&image_size=400&watermark=false',
    ringUrl: `/${PATH_PREFIX}/rings/profiles/B-NS/widths/7/ring_materials/PF14KY?ring_finish=POLISH%2CPOLISH&finish_type=FS&size=10&feature_group=G%2CN&groove_style=N&groove_group=15-N&grooves=15-N_ZIRCONIUM_ROCK&sleeve=NONE`
  },
  {
    description: 'Platinum',
    imageUrl:
      'https://assets.lashbrookdesigns.com/rings/profiles/DB/widths/7/ring_materials/PLAT/images/1?ring_finish=POLISH%2CPOLISH&finish_type=FS&weight=P&size=10&feature_group=G%2CN&groove_group=14-N&grooves=14-N_MOSAIC-DINOSAURBONEBLACK&image_size=400&watermark=false',
    ringUrl: `/${PATH_PREFIX}/rings/profiles/DB/widths/7/ring_materials/PLAT?ring_finish=POLISH%2CPOLISH&finish_type=FS&weight=P&size=10&feature_group=G%2CN&groove_style=N&groove_group=14-N&grooves=14-N_MOSAIC-DINOSAURBONEBLACK&sleeve=NONE`
  },
  {
    description: 'Zirconium',
    imageUrl:
      'https://assets.lashbrookdesigns.com/rings/profiles/F/widths/8/ring_materials/Z/images/1?ring_finish=POLISH&finish_type=F&size=10&feature_group=G%2CN&groove_group=16-OCE_MGA-CER-BLACK&grooves=16-OCE_METEORITE&image_size=400&watermark=false',
    ringUrl: `/${PATH_PREFIX}/rings/profiles/F/widths/8/ring_materials/Z?ring_finish=POLISH&finish_type=F&size=10&feature_group=G%2CN&groove_style=OCE&groove_group=16-OCE_MGA-CER-BLACK&grooves=16-OCE_METEORITE&sleeve=NONE`
  },
  {
    description: 'Damascus Steel',
    imageUrl:
      'https://assets.lashbrookdesigns.com/rings/profiles/F/widths/8/ring_materials/D-KINETIC/images/1?ring_finish=ACID&finish_type=F&size=10&feature_group=G%2CN&groove_group=12-OCE&grooves=12-OCE_14KR_POLISH&image_size=800&watermark=false',
    ringUrl: `/${PATH_PREFIX}/rings/profiles/F/widths/8/ring_materials/D-KINETIC?ring_finish=ACID&finish_type=F&size=10&feature_group=G%2CN&groove_style=OCE&groove_group=12-OCE&grooves=12-OCE_14KR_POLISH&sleeve=NONE`
  },
  {
    description: 'Damascus Steel',
    imageUrl:
      'https://assets.lashbrookdesigns.com/rings/profiles/B/widths/7/ring_materials/D-KINETIC/images/1?ring_finish=ACID&finish_type=F&size=10&feature_group=N&sleeve=HW-BLOODWOOD&image_size=1200&watermark=false',
    ringUrl: `/${PATH_PREFIX}/rings/profiles/B/widths/7/ring_materials/D-KINETIC?ring_finish=ACID&finish_type=F&size=10&feature_group=N&sleeve=HW-BLOODWOOD`
  },
  {
    description: 'Titanium',
    imageUrl:
      'https://assets.lashbrookdesigns.com/rings/profiles/F/widths/7/ring_materials/T/images/1?ring_finish=POLISH&finish_type=F&size=10&feature_group=G%2CN&groove_group=15-N&grooves=15-N_BMOP&sleeve=CER-WHITE&engraving_new=D_CER-BEACH&image_size=1200&watermark=false',
    ringUrl: `/${PATH_PREFIX}/rings/profiles/F/widths/7/ring_materials/T?ring_finish=POLISH&finish_type=F&size=10&feature_group=G%2CN&groove_style=N&groove_group=15-N&grooves=15-N_BMOP&sleeve=CER-WHITE&engraving_new=D_BEACH_T`
  },
  {
    description: 'Superconductor',
    imageUrl:
      'https://assets.lashbrookdesigns.com/rings/profiles/D/widths/6/ring_materials/NSC/images/1?ring_finish=BEAD&finish_type=F&size=10&feature_group=N&sleeve=SILVER&image_size=1200&watermark=false',
    ringUrl: `/${PATH_PREFIX}/rings/profiles/D/widths/6/ring_materials/NSC?ring_finish=BEAD&finish_type=F&size=10&feature_group=N&sleeve=SILVER`
  },
  {
    description: 'Titanium',
    imageUrl:
      'https://assets.lashbrookdesigns.com/rings/profiles/B-NS/widths/8/ring_materials/PFT/images/1?ring_finish=POLISH%2CPOLISH&finish_type=FS&size=10&feature_group=G%2CM&machine_pattern=%2CLCVAZTEC1_ZIRCONIUM_COLOR_CER-CRUSHEDSILVER&groove_group=16-N&grooves=16-N_ZIRCONIUM_POLISH&image_size=1200&watermark=false',
    ringUrl: `/${PATH_PREFIX}/rings/profiles/B-NS/widths/8/ring_materials/PFT?ring_finish=POLISH%2CPOLISH&finish_type=FS&size=10&feature_group=G%2CM&machine_pattern=%2CLCVAZTEC1_ZIRCONIUM_COLOR_CER-CRUSHEDSILVER&groove_style=N&groove_group=16-N&grooves=16-N_ZIRCONIUM_POLISH&sleeve=NONE`
  },
  {
    description: 'Carbon Fiber',
    imageUrl:
      'https://assets.lashbrookdesigns.com/rings/profiles/D/widths/9/ring_materials/FORGEDCF/images/1?ring_finish=&finish_type=F&size=10&feature_group=N&sleeve=TA&image_size=1200&watermark=false',
    ringUrl: `/${PATH_PREFIX}/rings/profiles/D/widths/9/ring_materials/FORGEDCF?ring_finish=NONE&finish_type=F&size=10&feature_group=N&sleeve=TA`
  }
];

export default SCREENSAVER_RINGS;
